import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { bopsApi } from '@Network';

interface UseStoresParams {
  retailer: string;
  search?: string;
  page?: number;
  size: number;
}

/** The client's store catalog for one retailer, paginated and searched server side. */
const useStores = ({ retailer, search = '', page = 1, size }: UseStoresParams) =>
  useQuery({
    queryKey: ['stores', retailer, search, page, size],
    queryFn: () => bopsApi.getStores({ retailer, search, page, size }),
    // Keeps the previous page visible while the next one loads, instead of emptying the list.
    placeholderData: keepPreviousData,
  });

export default useStores;
